import React, { useState } from "react";
import { Button, useTheme } from "@mui/material";
import { useAuth } from "../../contexts/AuthContext";
import useUserClaims from "../../hooks/useUserClaims";
import BillForm from "./BillForm";

const BillCreateForm = ({ onSuccess, billTypes = [] }) => {
  const theme = useTheme();
  const { user } = useAuth();
  const userClaims = useUserClaims(user);
  const [isOpen, setIsOpen] = useState(false);

  const handleButtonClick = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleSuccess = () => {
    if (onSuccess) {
      onSuccess();
    }
  };

  return (
    <div>
      {userClaims.admin || userClaims.subAdmin ? (
        <div>
          <Button
            variant="contained"
            color="primary"
            onClick={handleButtonClick}
          >
            Create New Bill
          </Button>

          <BillForm
            bill={null}
            isOpen={isOpen}
            onClose={handleClose}
            onSuccess={handleSuccess}
            billTypes={billTypes}
          />
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export default BillCreateForm;
